// import Modla from "bootstrap";

// import the latest version
import Swiper, {
  Navigation,
  Pagination,
  Autoplay,
  EffectCoverflow,
  EffectFade,
  Scrollbar,
} from "swiper";

// configure Swiper to use modules
Swiper.use([
  Navigation,
  Pagination,
  Autoplay,
  EffectCoverflow,
  EffectFade,
  Scrollbar,
]);

jQuery(function ($) {
  const menuSwiper = new Swiper(".menu-swiper", {
    spaceBetween: 30,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  $(".menu-list").each((index, element) => {
    const $this = $(element);
    const $cardMenu = $this.find("a.card-menu");

    $cardMenu.each((index, element) => {
      const $this = $(element);
      $this.attr("data-slide-index", index);
    });
  });

  const menuModal = document.querySelectorAll(".menu-modal");
  menuModal.forEach((element) => {
    element.addEventListener("show.bs.modal", (e) => {
      const $this = $(e.relatedTarget);
      menuSwiper.forEach((element) =>
        element.slideTo(Number($this.data("slide-index")))
      );
    });
  });
});
